
import {  toast } from 'react-toastify';


export  async function checkFormat(arr, predefinedFormat, callback) {
    try {
        const data = arr;
       // console.log("data:", data)
       // console.log(data.length , predefinedFormat.length)
        // Compare column numbers
        // if (data.length !== predefinedFormat.length) {
        //     throw new Error("Order of the columns not matching with the data template, please refer to the template");
        // }
         
        if (data.length > predefinedFormat.length){
          throw new Error("No. of columns exceeded. Please compare with the data template and retry");
        }
        if (data.length < predefinedFormat.length){
          throw new Error("Insufficient columns found, please validate with the data template and retry");
        }
        if (!data.every((columnName, index) => columnName === predefinedFormat[index])) {
          // Compare column names
            throw new Error("Column names do not match in the data uploaded. Please check and retry");
        }

        // Compare column order
        for (let i = 0; i < data.length; i++) {
            if (data[i] !== predefinedFormat[i]) {
              throw new Error("Order of the columns not matching with the data template, please refer to the template");
            }
        }
        const duplicates = findDuplicateColumns(arr);
        if (duplicates.length > 0) {
          throw new Error(`Duplicate column names found: ${duplicates.join(', ')}`);

        }

    } catch (error) {
        // Handle errors here, show modals, display error messages, etc.
        console.error(error.message);
        toast(error.message, {
            position: "top-right",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            });
            callback(error.message);
    }
}

const findDuplicateColumns = (columns) => {
  const counts = {};
  const duplicates = [];

  columns.forEach((column) => {
    counts[column] = (counts[column] || 0) + 1;
    if (counts[column] > 1 && !duplicates.includes(column)) {
      duplicates.push(column);
    }
  });

  return duplicates;
};


export async function checkDuplication(arr,predefinedFormat,callback){
  console.log(arr)
  const duplicates = findDuplicateColumns(arr);
  if (duplicates.length > 0) {
    toast(`Duplicate column names found: ${duplicates.join(', ')}`,
    { position: "top-right",
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      });

  }

}

  // Removing Surffixes "_1,_2" from coloumn name
  export const removeSuffix = (str) => {
    console.log(typeof(str))
    return str.replace(/_\d+$/, '');
  };

export const formatBytes = (a,b=2)=>{
  if(!+a)
  return"0 Bytes";
  
  const c=0>b?0:b,d=Math.floor(Math.log(a)/Math.log(1024));
  
  return`${parseFloat((a/Math.pow(1024,d)).toFixed(c))} ${["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"][d]}`

}